
import { Capacitor } from '@capacitor/core';

import { mapMutations, mapGetters } from 'vuex';

export default {
    props: {
        menu: { type: Object, required: true },
        restaurant: { type: Object, required: true },
        groupOrderEnabled: { type: Boolean, required: false }
    },
    data: t => ({
        activeSlideIndex: null,
        scrollY: null,
        scrollContainer: null,
        categoriesRects: [],
        menuCategories: null,
        menuCategoriesTop: null,
        transEnd: false,
    }),
    computed: {
        ...mapGetters('sideDrawer', ['sideDrawerType', 'sideDrawerData']),
        categories() {
            return this.menu.categories.filter(x => x.foods.length > 0);
        },
        showDishCarousel() {
            return this.activeSlideIndex !== null;
        },
        activeCategoryIndex() {
            try {
                if (!this.categoriesRects?.length || typeof this.scrollY !== 'number') {
                    return 0;
                }
                
                return this.categoriesRects.findIndex(x => {
                    if (!x) return false;
                    let offset = this.isNative ? -130 : -100;
                    if (window.innerWidth > 767) {
                        offset = -85;
                    }
                    return (this.scrollY - offset) <= x.bottom;
                });
            } catch (error) {
                console.warn('Error computing activeCategoryIndex:', error);
                return 0;
            }
        },
        allFoods() {
            return this.categories.reduce((sum, item) => {
                return [...sum, ...item.foods];
            }, []);
        },
        isNative() {
            return Capacitor.isNative;
        },
        isSticky() {
            return this.menuCategoriesTop !== null && this.menuCategoriesTop === 0;
        },
    },
    activated() {
        this.initComponent();
    },
    deactivated() {
        this.scrollY = 0;
        this.transEnd = false;
        if (this.allFoods.length) {
            this.scrollContainer.removeEventListener('scroll', this.onScroll);
        }
    },
    mounted() {
        this.initComponent();
        // this.checkForScrollToDish();
    },
    beforeDestroy() {
        if (this.allFoods.length) {
            this.scrollContainer.removeEventListener('scroll', this.onScroll);
        }
    },
    methods: {
        ...mapMutations(['setStatusBarVisible']),
        onScroll(e) {
            this.scrollY = (e && e.target.scrollTop) || 0;
            this.menuCategoriesTop = this.menuCategories.getBoundingClientRect().top;
        },
        scrollToCategory(categorySlug) {
            const { offsetTop } = this.$refs[categorySlug][0];
            const offset = this.isNative ? 83 : 68;
            let extraOffset = 25;
            if (window.innerWidth > 767) {
                extraOffset = -68;
                extraOffset = 12;
            }
            this.scrollContainer.scrollTo({
                top: (offsetTop - offset) - extraOffset,
                behavior: 'smooth',
            });
        },
        getCategoriesRects() {
            const domCategories = this.$el.querySelectorAll('.dish-category');
            domCategories.forEach(x => {
                this.categoriesRects.push(x.getBoundingClientRect());
            });
        },
        selectDish(id) {
            // this.setStatusBarVisible(false);
            const activeSlideIndex = this.allFoods.findIndex(x => x.id === id);
            this.activeSlideIndex = activeSlideIndex;
        },
        setMenuCategories() {
            const domMenuCategories = this.$el.querySelector('.categories-wrap');
            this.menuCategories = domMenuCategories;
        },
        closeCarousel() {
            this.activeSlideIndex = null;
            // this.setStatusBarVisible(true);
        },
        initComponent() {
            if (this.allFoods.length) {
                this.setMenuCategories();
                this.$nextTick();
                setTimeout(() => {
                    this.getCategoriesRects();
                }, 300);
            }
            setTimeout(() => {
                this.transEnd = true;
                this.$nextTick(() => {
                    if (this.allFoods.length) {
                        const pages = document.querySelectorAll('.page');
                        this.scrollContainer = pages[pages.length - 1];
                        this.scrollContainer.addEventListener('scroll', this.onScroll);
                        this.onScroll();
                    }
                    this.checkForScrollToDish();
                });

            }, 500);
        },
        checkForScrollToDish() {
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            if (params.showDish) {
                const div = document.getElementById(params.showDish);
                const offsetTop = div.offsetTop;
                let extraOffset = 80;
                if (window.innerWidth < 769) {
                    extraOffset = 98;
                }
                this.scrollContainer.scrollTo({
                    // top: (offsetTop - offset) - extraOffset,
                    top: offsetTop - extraOffset,
                    behavior: 'smooth',
                });
            }
        },
    },
};
